export const CampaignTurnedOnIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.5 13.7513H8L12.5 17.2513V5.41797L8 9.5H1.5V13.7513Z"
            stroke="#4DD15E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.5 18.0833V13.75H6.5V18.0833C6.5 18.9118 5.82843 19.5833 5 19.5833C4.17157 19.5833 3.5 18.9118 3.5 18.0833Z"
            stroke="#4DD15E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.6095 4.41832L17.2428 2.10594C16.7054 1.81869 16 2.14905 16 2.6948V7.3052C16 7.851 16.6886 8.1813 17.2428 7.89405L21.6095 5.58167C22.1302 5.32312 22.1302 4.69122 21.6095 4.41832Z"
            stroke="#4DD15E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default CampaignTurnedOnIcon
